import { fxHint } from "../lib/fx";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Headphones, Plus, Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { fmt } from "../lib/format";
import { BrandLogo } from "./BrandLogo";

export default function Header({ onNotifications, onSupport, unread = 0 }) {
  const { user, wallet } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="rl-glass sticky top-0 z-30 px-3 py-3 flex items-center justify-between gap-2 border-b border-slate-200"
      data-testid="app-header"
    >
      <button className="flex items-center gap-2 no-tap min-w-0 shrink" onClick={() => navigate("/")} data-testid="header-logo">
        <BrandLogo className="w-8 h-8 min-[390px]:w-9 min-[390px]:h-9 rounded-xl rl-gold-border shrink-0" testId="header-logo-img" />
        <div className="leading-tight text-left min-w-0">
          <div className="font-display font-extrabold text-[11px] min-[390px]:text-[13px] tracking-normal min-[390px]:tracking-wide rl-gold-text whitespace-nowrap">ROYAL LAKSHMI</div>
          <div className="flex items-baseline gap-1.5 whitespace-nowrap">
            <span className="text-[10px] font-bold rl-gold-text leading-none" data-testid="header-brand-tamil">ராயல் லக்ஷ்மி</span>
            {!user && <span className="text-[8px] text-slate-500 tracking-widest hidden min-[380px]:inline">PREMIUM PLAY</span>}
          </div>
        </div>
      </button>

      <div className="flex items-center gap-1.5 shrink-0">
        {user ? (
          <button
            onClick={() => navigate("/recharge")}
            className="flex items-center gap-1 rl-card px-2 py-1.5 no-tap"
            data-testid="header-wallet-balance"
          >
            <span className="font-mono font-bold text-blue-600 text-sm">{fmt(wallet?.total)}{fxHint(wallet?.total) && <span className="ml-1 text-[10px] text-slate-400 font-semibold" data-testid="fx-hint">{fxHint(wallet?.total)}</span>}</span>
            <span className="rl-gold-bg rounded-full w-5 h-5 flex items-center justify-center">
              <Plus className="w-3.5 h-3.5" strokeWidth={3} />
            </span>
          </button>
        ) : (
          <button
            onClick={() => navigate("/auth")}
            className="rl-gold-bg font-bold text-xs px-4 py-2 rounded-full no-tap"
            data-testid="header-login-btn"
          >
            Login / Sign Up
          </button>
        )}
        <button onClick={onNotifications} className="relative rl-card w-9 h-9 flex items-center justify-center no-tap" data-testid="header-notifications-btn">
          <Bell className="w-4.5 h-4.5 text-blue-600" />
          {unread > 0 && <span className="absolute -top-1 -right-1 bg-red-500 text-slate-900 text-[9px] rounded-full w-4 h-4 flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>}
        </button>
        <button onClick={onSupport} className="rl-card w-9 h-9 flex items-center justify-center no-tap" data-testid="header-support-btn">
          <Headphones className="w-4.5 h-4.5 text-blue-600" />
        </button>
      </div>
    </header>
  );
}
